module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapInitDone),
      expression: "mapInitDone"
    }],
    staticClass: "map-controls-container"
  }, [_c('i', {
    staticClass: "material-icons md-24 help-icon",
    attrs: {
      "id": "gmapsHelpIcon"
    }
  }, [_vm._v("help")]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsHelpIcon",
      "boundary": "viewport",
      "triggers": "click",
      "placement": "bottomleft",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('check').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM01) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Open').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM02) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Approved').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM03) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Rejected').url,
      "height": "42",
      "width": "24"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.SAGM04) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": _vm.iconMarkerFactory('Multiple').url,
      "height": "42",
      "width": "24",
      "opacity": "0.5"
    }
  }), _vm._v("\n        → "), _c('span', {
    staticStyle: {
      "padding-left": "4px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lang.SAGM05)
    }
  })])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "gmaps-container"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-283b1d37","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperApproval/GoogleMaps.vue
// module id = 1665
// module chunks = 1